import { css } from "@emotion/css";
import { RadioButton, RadioButtonGroup, Tooltip } from "@octopusdeploy/design-system-components";
import { InfoCircleIcon } from "@octopusdeploy/design-system-icons";
import { space, themeTokens } from "@octopusdeploy/design-system-tokens";
import type { SpaceResource } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import { SpaceMultiSelect } from "~/components/MultiSelect/SpaceMultiSelect";
interface ShareTemplateDialogProps {
    spaces: SpaceResource[];
    shareType: ShareTemplateSpacesType;
    selectedSpaces: string[];
    setShareType: (value: ((prevState: ShareTemplateSpacesType) => ShareTemplateSpacesType) | ShareTemplateSpacesType) => void;
    setSelectedSpaces: (value: ((prevState: string[]) => string[]) | string[]) => void;
    setCanSave: (value: ((prevState: boolean) => boolean) | boolean) => void;
}
export interface SharedSpaces {
    shareToAll: boolean;
    individualSpacesSharedTo: string[];
}
export enum ShareTemplateSpacesType {
    ShareAll = "Share All",
    ShareIndividual = "Share Individual",
    NotShared = "Not Shared"
}
export function ShareTemplateDialog({ spaces, shareType, selectedSpaces, setShareType, setSelectedSpaces, setCanSave }: ShareTemplateDialogProps) {
    function setCanSaveIfValid(type: ShareTemplateSpacesType, newSpaces: string[]) {
        if (type === ShareTemplateSpacesType.ShareIndividual) {
            setCanSave(selectedSpaces !== newSpaces);
        }
        else {
            setCanSave(true);
        }
    }
    return (<div className={shareFormStyles}>
            <RadioButtonGroup accessibleName={"Space sharing type"} value={shareType} onChange={(type) => {
            setShareType(type);
            setCanSaveIfValid(type, selectedSpaces);
        }} noMargin={true}>
                <div className={tooltipContainerStyles}>
                    <RadioButton value={ShareTemplateSpacesType.ShareAll} label="Share to all spaces"/>
                    <div className={tooltipStyles}>
                        <Tooltip content={"Includes current and future spaces"}>
                            <InfoCircleIcon size={20} color={themeTokens.color.icon.info}/>
                        </Tooltip>
                    </div>
                </div>
                <RadioButton value={ShareTemplateSpacesType.ShareIndividual} label="Share to selected spaces"/>
            </RadioButtonGroup>
            {shareType === ShareTemplateSpacesType.ShareIndividual && (<div className={selectSpacesContainerStyles}>
                    <SpaceMultiSelect label={"Add spaces where this process template will be used"} items={spaces} onChange={(spaces) => {
                setSelectedSpaces(spaces);
                setCanSaveIfValid(shareType, spaces);
            }} value={selectedSpaces}/>
                </div>)}
        </div>);
}
const tooltipContainerStyles = css({
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    marginLeft: "0 !important",
});
const tooltipStyles = css({
    marginLeft: space[8],
});
const selectSpacesContainerStyles = css({
    paddingLeft: space[32],
});
const shareFormStyles = css({
    display: "flex",
    flexDirection: "column",
    gap: space[32],
});
